import request from '@/utils/request'

// 查询投诉工单列表
export function listComplaintOrder(query) {
  return request({
    url: '/system/complaint-order/list',
    method: 'get',
    params: query,
  })
}

// 查询投诉工单分页
export function pageComplaintOrder(query) {
  return request({
    url: '/system/complaint-order/page',
    method: 'get',
    params: query,
  })
}

// 查询投诉工单详细
export function getComplaintOrder(data) {
  return request({
    url: '/system/complaint-order/detail',
    method: 'get',
    params: data,
  })
}

// 新增投诉工单
export function addComplaintOrder(data) {
  return request({
    url: '/system/complaint-order/add',
    method: 'post',
    data: data,
  })
}

// 修改投诉工单
export function updateComplaintOrder(data) {
  return request({
    url: '/system/complaint-order/edit',
    method: 'post',
    data: data,
  })
}

// 删除投诉工单
export function delComplaintOrder(data) {
  return request({
    url: '/system/complaint-order/delete',
    method: 'post',
    data: data,
  })
}

// 导入投诉工单数据
export function importComplaintOrderData(data) {
  return request({
    url: '/system/complaint-order/importData',
    method: 'post',
    data: data,
  })
}

// 修改投诉工单状态
export function changeComplaintOrderStatus(data) {
  return request({
    url: '/system/complaint-order/editStatus',
    method: 'post',
    data: data,
  })
}

// 完结投诉工单
export function closeComplaintOrder(data) {
  return request({
    url: '/system/complaint-order/closeOrder',
    method: 'post',
    data: data,
  })
}
